/**
 * Top Navbar Tour Configuration
 * Introduces users to the top navigation bar features
 */

import { TourDefinition } from './tour.types';

export const navbarTour: TourDefinition = {
  id: 'navbar-tour',
  name: 'Top Navigation',
  page: '/dashboard', // Starts on dashboard since navbar is always visible
  version: 3, // Updated to show all items to all users
  nextTourId: 'dashboard-tour', // Chain to dashboard tour after completion
  steps: [
    {
      id: 'navbar-intro',
      targetSelector: '[data-tour="top-navbar"]',
      title: 'Top Navigation Bar',
      description:
        'The navigation bar gives you quick access to search, notifications, and your account settings.',
      placement: 'bottom',
    },
    {
      id: 'navbar-search-step',
      targetSelector: '[data-tour="navbar-search"]',
      title: 'Global Search',
      description:
        'Search for leads, appointments, calls, reminders, and resources from anywhere in the app. Just start typing!',
      placement: 'bottom',
    },
    {
      id: 'navbar-agency-step',
      targetSelector: '[data-tour="navbar-agency"]',
      title: 'Agency Selector',
      description:
        'If you\'re part of multiple agencies, switch between them here. Your data and settings will update accordingly.',
      placement: 'bottom',
    },
    {
      id: 'navbar-notifications-step',
      targetSelector: '[data-tour="navbar-notifications"]',
      title: 'Notifications',
      description:
        'Stay informed! You\'ll see alerts here for new leads, missed calls, upcoming appointments, and more.',
      placement: 'bottom',
    },
    {
      id: 'navbar-quick-actions-step',
      targetSelector: '[data-tour="navbar-quick-actions"]',
      title: 'Quick Actions',
      description:
        'Need to do something fast? Quick Actions let you add leads, start dialing, schedule appointments, and more with one click!',
      placement: 'bottom',
    },
    {
      id: 'navbar-insurabot-step',
      targetSelector: '[data-tour="navbar-insurabot"]',
      title: 'InsuraBot - Your AI Assistant',
      description:
        'Meet InsuraBot! Click here to chat with our AI assistant. Ask questions about the app, get help navigating, or find information quickly.',
      placement: 'bottom',
    },
    {
      id: 'navbar-user-step',
      targetSelector: '[data-tour="navbar-user-menu"]',
      title: 'Your Profile',
      description:
        'Access your profile, change your status, view settings, and log out from here. The colored dot shows your current status.',
      placement: 'bottom',
    },
  ],
};
